import {
  AlignItems,
  Body2,
  Bold,
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  Display3,
  FlexDirection,
  Icon,
  IconVariant,
  Join,
  JustifyContent,
  Space,
  Visible,
} from '@gousto-internal/citrus-react'
import React from 'react'

import { InlineLink } from '../../../InlineLink/InlineLink'
import { OUR_SUPPLIERS_COPY } from '../../../../config'

function SupplierBullets({ children }: { children: React.ReactNode }) {
  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Row} alignItems={AlignItems.FlexStart}>
      <Box color={Color.Success_400}>
        <Icon name="tick" variant={IconVariant.Inherit} />
      </Box>
      <Space direction="horizontal" size={2} />
      <Body2 size={[4, null, null, 5]} color={Color.White}>
        {children}
      </Body2>
    </Box>
  )
}

export function SupplierContent({ onClick }: { onClick: () => void }) {
  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
    >
      <Box width={[null, null, '540px', '450px']}>
        <Space size={[4, null, null, 10]} />
        <Display3 size={[11, 13]} color={Color.White}>
          {OUR_SUPPLIERS_COPY.heading}
        </Display3>
        <Space size={[4, null, null, 6]} />
        <Join with={<Space size={4} />}>
          <SupplierBullets>
            <Bold>Quality you can taste</Bold> from brands and suppliers who share our values.
          </SupplierBullets>
          <SupplierBullets>
            <Bold>100% British</Bold> fresh meat from <Bold>trusted UK farms.</Bold>
          </SupplierBullets>
          <SupplierBullets>
            <Bold>
              Proud to be a{' '}
              <InlineLink backgroundStyle="dark" href={OUR_SUPPLIERS_COPY.sustainabilityURL}>
                B Corp™,{' '}
              </InlineLink>
            </Bold>{' '}
            meeting the highest environmental and social standards.
          </SupplierBullets>
        </Join>

        <Space size={6} />
        <Visible display={['none', 'block']}>
          <Button
            width="320px"
            onClick={onClick}
            height="48px"
            colorVariant={ButtonColorVariant.Secondary}
          >
            {OUR_SUPPLIERS_COPY.ctaLabel}
          </Button>
          <Space size={6} />
        </Visible>
      </Box>
    </Box>
  )
}
